module.exports = __webpack_public_path__ + "img/ogp.4d6cecc.png";